import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
// ...existing code...

// Apply theme immediately before React renders
(function() {
  const darkmode = localStorage.getItem('darkmode');
  const htmlElement = document.documentElement;
  
  // Remove any existing theme classes first
  htmlElement.classList.remove('darkmode');
  
  // Force dark theme by default
  if (darkmode !== 'active') {
    localStorage.setItem('darkmode', 'active');
  }
  
  // Apply dark theme
  htmlElement.classList.add('darkmode');
})();

// Now render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
